import { Link } from "react-router-dom";
import { Instagram, Facebook, Mail } from "lucide-react";

export default function Footer() {
  return (
    <footer className="mt-32 border-t border-[#D8D6D0] bg-[#F0EFEA]" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid md:grid-cols-4 gap-12">
        <div>
          <div className="flex items-center gap-2 mb-4">
            <div className="w-8 h-8 rounded-full bg-[#1B2A22] text-white flex items-center justify-center font-display font-bold text-sm">C</div>
            <span className="font-display font-bold text-lg">Caravan Reisen</span>
          </div>
          <p className="text-sm text-[#1B2A22]/70 leading-relaxed">
            Reisemobilvermietung mit Herz. Wir bringen dich sicher auf die Straße – vom Wochenendtrip bis zur großen Reise.
          </p>
        </div>

        <div>
          <h4 className="text-sm font-semibold uppercase tracking-wider text-[#1B2A22]/60 mb-4">Entdecken</h4>
          <ul className="space-y-3 text-sm">
            <li><Link to="/fahrzeuge" className="hover:text-[#C05C42]">Fahrzeugflotte</Link></li>
            <li><Link to="/ueber-uns" className="hover:text-[#C05C42]">Über uns</Link></li>
            <li><Link to="/kontakt" className="hover:text-[#C05C42]">Kontakt & FAQ</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-sm font-semibold uppercase tracking-wider text-[#1B2A22]/60 mb-4">Rechtliches</h4>
          <ul className="space-y-3 text-sm">
            <li><Link to="/impressum" className="hover:text-[#C05C42]" data-testid="footer-impressum">Impressum</Link></li>
            <li><a href="#" className="hover:text-[#C05C42]">Datenschutz</a></li>
            <li><a href="#" className="hover:text-[#C05C42]">AGB</a></li>
          </ul>
        </div>

        <div>
          <h4 className="text-sm font-semibold uppercase tracking-wider text-[#1B2A22]/60 mb-4">Kontakt</h4>
          <p className="text-sm mb-4">info@caravan-reisen.com<br/>+49 (0)35872 / 6990-10</p>
          <div className="flex gap-3">
            <a href="#" className="w-9 h-9 rounded-full border border-[#D8D6D0] flex items-center justify-center hover:bg-white"><Instagram size={16}/></a>
            <a href="#" className="w-9 h-9 rounded-full border border-[#D8D6D0] flex items-center justify-center hover:bg-white"><Facebook size={16}/></a>
            <a href="mailto:info@caravan-reisen.com" className="w-9 h-9 rounded-full border border-[#D8D6D0] flex items-center justify-center hover:bg-white"><Mail size={16}/></a>
          </div>
        </div>
      </div>
      <div className="border-t border-[#D8D6D0] py-6 text-center text-xs text-[#1B2A22]/60">
        © {new Date().getFullYear()} Caravan Reisen – Inh. Wieland Neumann. Alle Rechte vorbehalten.
      </div>
    </footer>
  );
}
